<p-toast></p-toast>

<p-sidebar [(visible)]="isVisibleDriverTransactionDetail"
           [position]="'right'"
           [baseZIndex]="11000"
           (onHide)="cancel()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
            <div class="order-details-head-font">Reference ID: </div>
            <div class="order-details-payment-head ml-3">{{transaction.RequestRefNumber}}</div>
    </ng-template>

    <div class="bg-menu">
        <p-tabMenu [model]="menuItems" [scrollable]="true" [activeItem]="menuItems[0]"></p-tabMenu>
    </div>

    <ng-container *ngIf="!isCashout() 
                        && transaction.XpressUserWalletOperationTypeId !== userWalletOperationType.RiderTip 
                        && transaction.XpressUserWalletOperationTypeId !== userWalletOperationType.RiderEarning ">
        <div class="order-detail-title">
            Transaction Details
        </div>

        <div class="flex flex-row">
            <div class="order-detail-column30">
                <div class="order-detail-label">Partner TX ID:</div>
            </div>
            <div class="order-detail-column70">
                <div class="order-detail-value od-tx-id">
                    {{transaction.PaymentTransactionId}}
                </div>
            </div>
        </div>
        <div class="flex flex-row">
            <div class="order-detail-column30">
                <div class="order-detail-label">Booking ID:</div>
            </div>
            <div class="order-detail-column70">
                <div class="order-detail-value od-tx-id">
                    {{transaction.BookingId}}
                </div>
            </div>
        </div>
        <div class="flex flex-row">
            <div class="order-detail-column30">
                <div class="order-detail-label">Transaction Status:</div>
            </div>
            <div class="order-detail-column70">
                <div class="order-detail-value od-tx-status">
                    {{transaction.TransactionStatus}}
                </div>
            </div>
        </div>
        <div class="flex flex-row">
            <div class="order-detail-column30">
                <div class="order-detail-label">Payment Method:</div>
            </div>
            <div class="order-detail-column70">
                <div class="order-detail-value">
                    {{transaction.PaymentMethodText}}
                </div>
            </div>
        </div>
        <div class="flex flex-row">
            <div class="order-detail-column30">
                <div class="order-detail-label">Base fare:</div>
            </div>
            <div class="order-detail-column70">
                <div class="order-detail-value">
                    {{transaction.BaseFare}}
                </div>
            </div>
        </div>
        <div class="flex flex-row">
            <div class="order-detail-column30">
                <div class="order-detail-label">Distance:</div>
            </div>
            <div class="order-detail-column70">
                <div class="order-detail-value">
                    {{transaction.DistanceFare}}
                </div>
            </div>
        </div>
        <div class="flex flex-row">
            <div class="order-detail-column30">
                <div class="order-detail-label">Time:</div>
            </div>
            <div class="order-detail-column70">
                <div class="order-detail-value">
                    {{transaction.TripDurationCharge}}
                </div>
            </div>
        </div>
        <div class="flex flex-row">
            <div class="order-detail-column30">
                <div class="order-detail-label">Surge Charges:</div>
            </div>
            <div class="order-detail-column70">
                <div class="order-detail-value">
                    {{transaction.SurgeCharges}}
                </div>
            </div>
        </div>
        <div class="flex flex-row">
            <div class="order-detail-column30">
                <div class="order-detail-label">Toll:</div>
            </div>
            <div class="order-detail-column70">
                <div class="order-detail-value">
                    {{transaction.TollsAmount}}
                </div>
            </div>
        </div>
        <div class="flex flex-row">
            <div class="order-detail-column30">
                <div class="order-detail-label">Ride Insuarance Opt-in:</div>
            </div>
            <div class="order-detail-column70">
                <div class="order-detail-value">
                    {{transaction.RiderInsuranceAmount}}
                </div>
            </div>
        </div>
        <div class="flex flex-row">
            <div class="order-detail-column30">
                <div class="order-detail-label">Transaction amount:</div>
            </div>
            <div class="order-detail-column70">
                <div class="order-detail-value">
                    {{transaction.Amount}}
                </div>
            </div>
        </div>
        <div class="flex flex-row">
            <div class="order-detail-column30">
                <div class="order-detail-label">Tip:</div>
            </div>
            <div class="order-detail-column70">
                <div class="order-detail-value">
                    {{transaction.TipAmount}}
                </div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="transaction.XpressUserWalletOperationTypeId === userWalletOperationType.RiderTip">
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">TIP ID</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.PaymentTransactionId}}</div>
        </div>
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Booking ID</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.BookingId}}</div>
        </div>
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Amount</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.Amount}}</div>
        </div>
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Transaction Date</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.CreatedAtStr}}</div>
        </div>
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Transaction Time</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.CreatedAtTime}}</div>
        </div>
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Payment Method</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.PaymentMethodText}}</div>
        </div>
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Notes</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.Notes || '-'}}</div>
        </div>
    </ng-container>

    <ng-container *ngIf="transaction.XpressUserWalletOperationTypeId === userWalletOperationType.RiderEarning">
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Partner TX ID</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.PaymentTransactionId}}</div>
        </div>
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Booking ID</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.BookingId}}</div>
        </div>
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Amount</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.Amount}}</div>
        </div>
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Transaction Date</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.CreatedAtStr}}</div>
        </div>
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Transaction Time</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.CreatedAtTime}}</div>
        </div>
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Transaction Status</div>
            <div class="col-6 p-0 transaction-detail-font od-tx-status">{{transaction.TransactionStatus}}</div>
        </div>
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Payment Method</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.PaymentMethodText}}</div>
        </div>

        <hr class="mt-5 mb-5">

        <div class="ml-4 transaction-detail-font flex flex-row flex-wrap">
            <div class="col-12 p-0">
                <div class="ml-2 flex flex-row flex-wrap">
                    <div class="col-5 p-0 mb-3">Total Fare</div>
                    <div class="col-6 p-0 mb-1 ml-6 pl-2">{{riderOrderDetail?.InitialTotalFareAmount}}</div>

                    <div class="col-11 p-0 flex">
                        <div class="col-6 p-0 mb-2">Waiting Fee</div>
                        <div class="col-6 p-0 mb-2 ml-4">{{riderOrderDetail?.WaitingFeeAmountText}}</div>
                    </div>
                    <div class="col-11 p-0 flex">
                        <div class="col-6 p-0 mb-2">Ride Insurance Opt-in</div>
                        <div class="col-6 p-0 mb-2 ml-4">₱ {{riderOrderDetail?.RiderInsuranceAmount}}</div>
                    </div>
                    <div class="col-11 p-0 flex">
                        <div class="col-6 p-0 mb-2">Pickup Surcharge</div>
                        <div class="col-6 p-0 mb-2 ml-4">₱ {{riderOrderDetail?.PickupSurgeAmount}}</div>
                    </div>
                    <div class="col-11 p-0 flex">
                        <div class="col-6 p-0 mb-2">Distance Surcharge</div>
                        <div class="col-6 p-0 mb-2 ml-4">{{riderOrderDetail?.SurgeCharges}}</div>
                    </div>
                    <div class="col-11 p-0 flex">
                        <div class="col-6 p-0 mb-2">Distance Fee</div>
                        <div class="col-6 p-0 mb-2 ml-4">{{riderOrderDetail?.DistanceFare}}</div>
                    </div>
                    <div class="col-11 p-0 flex">
                        <div class="col-6 p-0 mb-2">Xpress Service Fee</div>
                        <div class="col-6 p-0 mb-3 ml-4">₱ {{riderOrderDetail?.ServiceFeeAmount}}</div>
                    </div>

                    <div class="col-11 p-0 flex">
                        <div class="col-6 p-0 mb-3">Promo</div>
                        <div class="col-6 p-0 mb-3 ml-4">₱ {{riderOrderDetail?.PromoAmount}}</div>
                    </div>
                    <div class="col-11 p-0 flex">
                        <div class="col-6 p-0 mb-3">Tip</div>
                        <div class="col-6 p-0 mb-3 ml-4">{{riderOrderDetail?.TipAmount}}</div>
                    </div>
                    <div class="col-11 p-0 flex">
                        <div class="col-6 p-0 mb-3">Amount Paid</div>
                        <div class="col-6 p-0 mb-3 ml-4">{{riderOrderDetail?.Amount}}</div>
                    </div>
                    <div class="col-11 p-0 flex">
                        <div class="col-6 p-0 mb-3">Xpress Service</div>
                        <div class="col-6 p-0 mb-3 ml-4">₱ {{riderOrderDetail?.ServiceFeeAmount}}</div>
                    </div>
                    <div class="col-11 p-0 flex">
                        <div class="col-6 p-0 mb-3">Driver Earnings</div>
                        <div class="col-6 p-0 mb-3 ml-4">₱ {{riderOrderDetail?.NetFare}}</div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <div class="flex justify-content-end px-3 py-3">
        <anti-fraud-actions [transactionId]="transaction.PaymentTransactionId"
                            [transactionStatus]="transaction.TransactionStatus"
                            [isPaid]="transaction.IsPaid"
                            [isVoided]="transaction.IsVoided"
                            (actionCompleted)="onAntiFraudActionCompleted()">
        </anti-fraud-actions>
    </div>

    <ng-container *ngIf="isCashout()">
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Reference ID</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.RequestRefNumber}}</div>
        </div>
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Transaction ID</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.PaymentTransactionId}}</div>
        </div>
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Transaction Date</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.CreatedAtStr}}</div>
        </div>
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Transaction Time</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.CreatedAtTime}}</div>
        </div>
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Transaction Status</div>
            <div class="col-6 p-0 transaction-detail-font od-tx-status">{{transaction.TransactionStatus}}</div>
        </div>
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Payment Method</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.PaymentMethodText}}</div>
        </div>
        <div class="mt-4 ml-4 flex flex-row">
            <div class="col-6 p-0 transaction-detail-font">Amount</div>
            <div class="col-6 p-0 transaction-detail-font">{{transaction.Amount}}</div>
        </div>
    </ng-container>
</p-sidebar>
